<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="4">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$t('labels.name')" :sortable="resourceState.sort" :col="'name'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.email')" :sortable="resourceState.sort" :col="'email'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.role')" @click="applySort"></bs-th>
            <th></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ r.name }}</td>
          <td>{{ r.email }}</td>
          <td>{{ r.role ? r.role.name : '' }}</td>
          <td class="t4">
            <bs-action
                :icon="['fas', 'user-tag']"
                :tip="$t('labels.action_resource', { action: $t('labels.assign'), resource: $tc('labels.client', 0) })"
                class="btn-warning"
                @click="assign(r)"></bs-action>
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
            <bs-action
                :icon="['fal', 'user-lock']"
                :tip="$t('labels.action_resource', { action: $t('labels.assume'), resource: $tc('labels.user', 1) })"
                class="btn-warning"
                @click="assign(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <div class="row">
            <div class="col-6">
              <input-field :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></input-field>
            </div>
            <div class="col-6">
              <select-field :name="'role_id'" :label="$t('labels.role')" v-model="resource.role_id" :error="slotProps.error">
                <option v-for="role in roles" :key="'r' + role.id" :value="role.id">{{ role.name }}</option>
              </select-field>
            </div>
          </div>
          <input-field :type="'email'" :name="'email'" :label="$t('labels.email')" v-model="resource.email" :error="slotProps.error"></input-field>
          <input-field :type="'password'" :name="'password'" :label="$t('labels.password')" :help="$t('messages.password_not_required')" v-model="resource.password" :error="slotProps.error"></input-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
    <bs-modal :name="'assignClients'" :label="$t('labels.action_resource', { action: $t('labels.assign'), resource: $tc('labels.client', 0) })">
      <bs-form :submit="$t('labels.assign')" @submit="assignClients">
        <template v-if="!dataLoading">
          <bs-badge class="clickable"
                    v-for="client in clients"
                    :key="'c' + client.id"
                    :class="assignedClients.includes(client.id) ? 'badge-secondary' : 'badge-light'"
                    @click="toggle(client.id)"
          >{{ client.name }}</bs-badge>
        </template>
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { resourceControl } from '../../mixins/resourceControl'
import { mapState } from 'vuex'

export default {
  name: 'Users',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'user-friends'],
      assignedClients: [],
      resource: {
        name: '',
        email: '',
        role_id: null,
        password: '',
        password_confirmation: ''
      }
    }
  },
  computed: {
    ...mapState({
      resourceStore: state => state.usersStore,
      resourceState: state => state.usersState,
      roles: state => state.roles.data,
      clients: state => state.clientsStore,
      resources: state => state.users
    })
  },
  methods: {
    assign (o) {
      this.activeId = o.id
      this.assignedClients = o.clients
      this.$modal.show('assignClients')
    },
    toggle (id) {
      if (this.assignedClients.includes(id)) {
        this.assignedClients.splice(this.assignedClients.indexOf(id), 1)
      } else {
        this.assignedClients.push(id)
      }
    },
    assignClients () {
      this.$store.dispatch('update', { path: 'user-clients', collection: this.$options.name, resource: { id: this.activeId, clients: this.assignedClients } }).then(() => {
        this.$modal.hide('assignClients')
      })
    }
  }
}
</script>
